<template>
  <div>
    <v-container class="questions d-flex align-center">
      <v-row
        no-gutters
        class="flex-column align-center flex-lg-row align-start justify-lg-space-between  "
      >
        <!-- Dinamik içerik geldiğinde key id olarak değişecek -->
        <!-- Ayrıca buttonlar mobil ve ipad ekranında hoş durmuyor resimlerin kaldırılması düşünülebilir -->

        <v-col cols="11">
          <v-tabs
            color="#224099"
            vertical
            class="d-flex flex-column flex-sm-row align-center"
            active-class="more--information--btn--active"
          >
            <v-tab class="more--information--btn mr-10">
              Özel Sağlık Sigortası
            </v-tab>

            <v-tab class="more--information--btn mr-10">
              Tamamlayıcı Sağlık Sigortası
            </v-tab>

            <v-tab class="more--information--btn mr-10">
              Doğum Sigortası
            </v-tab>
            <v-tab class="more--information--btn mr-10 ">
              Seyahat Sağlık Sigortası
            </v-tab>
            <v-tab class="more--information--btn mr-10 ">
              Yabancı Sağlık Sigortası
            </v-tab>

            <v-tab-item class="questions--content mt-10 mt-lg-0">
              <h4>Özel Sağlık Sigortası Avantajları</h4>
              <p>
                Güvenilir bir sağlık sigortası planı sizi ani sağlık
                harcamalarından korur. Sağlık sigortasına sahip olmanın birçok
                faydası vardır:
              </p>
              <ul>
                <li>Özel hastanelerden düşük primler ile hizmet alırsınız.</li>
                <li>Hastane ve doktor seçiminde tamamen özgür olursunuz.</li>
                <li>
                  Özel sağlık sigortası yaptırarak vergi avantajlarından
                  yararlanabilirsiniz.
                </li>
                <li>
                  Geniş plan seçeneği ile talep edeceğiniz teminatları
                  poliçenize ekleyebilirsiniz.
                </li>
                <li>
                  Sadece kendi sağlığınızı değil sevdiklerinizin de sağlığını
                  güvence altına alabilirsiniz.
                </li>
              </ul>
            </v-tab-item>
            <v-tab-item class="questions--content mt-10 mt-lg-0">
              <h4>
                Sağlık sigortası poliçesi, hastalıklar veya yaralanmalar için
                tıbbi masrafları kapsar.
              </h4>
              <p>
                Güvenilir bir sağlık sigortası planı sizi ani sağlık
                harcamalarından korur. Sağlık sigortasına sahip olmanın birçok
                faydası vardır:
              </p>
              <ul>
                <li>
                  SGK Anlaşmalı özel hastanelerde SGK’nın karşılamadığı veya
                  ücret limitlerini aşan tedavi giderleri karşılanır.
                </li>
                <li>Anlaşmalı özel hastanelerden %100 hizmet alırsınız.</li>
                <li>
                  3 yıl üst üste yenilemeniz durumunda ömür boyu yenileme
                  garantisi kazanırsınız.
                </li>
                <li>
                  Limitlerin üstü olan harcamalar için özel indirimler
                  uygulanır.
                </li>
                <li>
                  Check – up ve diyetisyen gibi hizmetlerden plana göre ücretsiz
                  yaralanabilirsiniz.
                </li>
                <li>
                  Yaygın hastane ağı ile dilediğiniz hastaneyi tercih
                  edebilirsiniz.
                </li>
              </ul>
            </v-tab-item>
            <v-tab-item class="questions--content mt-10 mt-lg-0">
              <h4>
                Doğum Sigortası Avantajları
              </h4>
              <p>
                Doğum sigortası; hamilelik sürecinde aylık ve haftalık yapılan
                kontrolleri, doğum şekline göre meydana gelen sezaryen ya da
                normal doğum masraflarını, doğum sürecinde annede ya da bebekte
                oluşan sağlık sorunlarını teminat kapsamına almaktadır.
              </p>
              <ul>
                <li>
                  Doğumunuzu düşük primler ile anlaşmalı özel hastanelerde
                  gerçekleştirebilirsiniz.
                </li>
                <li>
                  Hamilelik döneminde veya doğum esnasında oluşabilecek medikal
                  harcamaları karşılayabilirsiniz.
                </li>
                <li>
                  Bekleme süreli veya bekleme süresiz olan paketlerden birini
                  tercih edebilirsiniz.
                </li>
                <li>
                  Ek hizmetler ile psikolojik destek ve diyetisyen
                  hizmetlerinden planınıza göre ücretsiz yararlanabilirsiniz.
                </li>
              </ul>
            </v-tab-item>
            <v-tab-item class="questions--content mt-10 mt-lg-0">
              <h4>
                Seyahat Sağlık Sigortası Avantajları
              </h4>
              <p>
                Seyahatleriniz sırasında karşılaşabileceğiniz ani rahatsızlık ve
                hastalıklara karşı koruma sağlayarak, asistans hizmetleriyle de
                hayatınızı kolaylaştırır.
              </p>
              <p>Seyahat sağlık sigortası ile;</p>
              <ul>
                <li>
                  Vize almak için gerekli olan sigorta sözleşmesine ek sağlık
                  hizmetlerinden yararlanma fırsatı.
                </li>
                <li>
                  Vize almak için gerekli olan sigorta sözleşmesine ek sağlık
                  hizmetlerinden yararlanma fırsatı.
                </li>
                <li>
                  Poliçe vadesini siz belirlersiniz.
                </li>
                <li>
                  Yurt dışında karşılaşabileceğiniz sağlık sorunlarına karşı
                  güvence altında olursunuz.
                </li>
                <li>
                  Geniş plan seçenekleriyle ihtiyacınıza özel plan seçimi
                  yapabilirsiniz.
                </li>
              </ul>
            </v-tab-item>
            <v-tab-item class="questions--content mt-10 mt-lg-0">
              <h4>
                Yabancı Sağlık Sigortası Avantajları
              </h4>
              <p>
                Seyahatleriniz sırasında karşılaşabileceğiniz ani rahatsızlık ve
                hastalıklara karşı koruma sağlayarak, asistans hizmetleriyle de
                hayatınızı kolaylaştırır.
              </p>

              <ul>
                <li>
                  Türkiye de kalabilmek için gerekli olan izinler için gerekli
                  olan sigortaya dakikalar içerisinde sahip olabilme fırsatı.
                </li>
                <li>
                  Türkiye’de bulunduğunuz sürece sağlık sorunlarına karşı
                  güvence altında olursunuz.
                </li>
                <li>
                  Gelir vergisi konunu gereğince vergi avantajlarından
                  yararlanabilirsiniz.
                </li>
                <li>
                  İster ülkenize ait ister Türkiye’ye ait kredi kartı ile ödeme
                  imkânı.
                </li>
                <li>
                  Kritik hastalığın tedavisine karşı koruma altında olursunuz.
                </li>
              </ul>
            </v-tab-item>
          </v-tabs>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import '@/css/variables';
ul {
  list-style: none;
}

ul li:before {
  content: '✓';
  color: $secondary;
  font-weight : 900;
  margin-right: 10px;
}
</style>
